var map = {
	"./components/file-field.en-US.yml": "3t0M",
	"./components/file-field.es-PY.yml": "L1zw",
	"./components/file-field.fr-FR.yml": "i4zs",
	"./components/file-field.pt-BR.yml": "21vo",
	"./components/paginator.en-US.yml": "FOZl",
	"./components/paginator.es-PY.yml": "Ts5K",
	"./components/paginator.fr-FR.yml": "eElp",
	"./components/paginator.pt-BR.yml": "QalG",
	"./core.en-US.yml": "Mmr3",
	"./core.es-PY.yml": "WR/j",
	"./core.fr-FR.yml": "oUuf",
	"./core.pt-BR.yml": "mrai",
	"./errors.en-US.yml": "iG3w",
	"./errors.es-PY.yml": "ZOg5",
	"./errors.fr-FR.yml": "TmM2",
	"./errors.pt-BR.yml": "LdiD",
	"./models/admin.pt-BR.yml": "+JWY",
	"./models/supplier.pt-BR.yml": "aln5",
	"./models/user.pt-BR.yml": "XBsK"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NJt3";